// extracted by mini-css-extract-plugin
export default {"reasonText":"e2PN1nsCP0ltnfk8mVyj"};